export const mtfFunction = {
  getCorrectAnsObj: (pairs) => {
    const correctAnsObj = {};
    pairs.forEach((item) => {
      correctAnsObj[item.left._id] = item.right._id;
    });
    return correctAnsObj;
  },
  getSubmittedResponseObj: (submittedResponseArr) => {
    const submittedResponseObj = {};
    submittedResponseArr.forEach((item) => {
      submittedResponseObj[item.leftId] = item.rightId || '';
    });
    return submittedResponseObj;
  },
  evalMTFAns: (submittedResponseArr, pairs) => {
    let correctAns = true;
    const submittedAnsObj = mtfFunction.getSubmittedResponseObj(submittedResponseArr);
    const correctAnsObj = mtfFunction.getCorrectAnsObj(pairs);
    Object.keys(submittedAnsObj).forEach((leftItem) => {
      if (submittedAnsObj[leftItem] !== correctAnsObj[leftItem]) {
        correctAns = false;
      }
    });
    return correctAns.toString().toUpperCase();
  }
};

export const ftbFunction = {
  evalFTBAnswer: (mappedClickedObj) => {
    let evalAns = true;
    Object.keys(mappedClickedObj).forEach((objKey) => {
      if (objKey !== mappedClickedObj[objKey]) {
        evalAns = false;
      }
    });
    return evalAns.toString().toUpperCase();
  }
};

export const evaluateSelectResponse = (responseString, options) => {
  const parsedResponse = responseString.split(',');
  const isCorrect = options.every(({ optionEvaluation }, index) => {
    if (optionEvaluation) {
      return parsedResponse.includes(index.toString());
    }
    return !parsedResponse.includes(index.toString());
  });
  return isCorrect.toString().toUpperCase();
};
